import type { BookingStore } from './interfaces'

export const createInitialState = (): BookingStore => ({
  currentById: {},
  listById: {},
  finishedById: {},
  countdown: null,
  modalJoinDemoLesson: false,
  modalJoinPaidLesson: false,
  bookingTrigger: 0,
  icsLink: null,
  icsProcessing: false,
})
